"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./qrCodePopup.scss");
var _soundIcon = _interopRequireDefault(require("../assets/sound-icon.svg"));
var _qrError = _interopRequireDefault(require("../assets/qr-error.json"));
var _RenderAnimation = _interopRequireDefault(require("../../teacherDashboard/teacher/lotties/RenderAnimation"));
var _state = require("../state");
var _incorrectQrcode = _interopRequireDefault(require("../assets/incorrect-qrcode.mp3"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var QRcodePopup = function QRcodePopup(_ref) {
  var _ref$errorInfo = _ref.errorInfo,
    errorInfo = _ref$errorInfo === void 0 ? null : _ref$errorInfo,
    setLoading = _ref.setLoading,
    setError = _ref.setError;
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    showQRPopup = _useAuthSigninState.showQRPopup,
    setShowQRPopup = _useAuthSigninState.setShowQRPopup;
  if (!errorInfo && !showQRPopup) {
    return null;
  }
  var audio = new Audio(_incorrectQrcode["default"]);
  (0, _react.useEffect)(function () {
    audio.play();
    trackEventsForGuests("Viewed SplashLearn QR Code Required Popup", {
      "mp_login_user_type": "student"
    }, {
      send_mixpanel: true
    });
    return function () {
      audio.pause();
    };
  }, []);
  var QRCodeExpired = (0, _react.useMemo)(function () {
    if (errorInfo === "This QR code is expired. Please contact your teacher.") {
      return true;
    } else {
      return false;
    }
  }, [errorInfo]);
  var loginViaClassCode = function loginViaClassCode() {
    window.location.hash = "#student-klasscode?fromPage=QR code Required Popup";
    trackEventsForGuests("Interacted SplashLearn QR code Required Popup", {
      "mp_login_user_type": "student",
      "Clicked on": "Login via class code"
    }, {
      send_mixpanel: true
    });
  };
  var scanAgain = function scanAgain(clickedOn) {
    setLoading(false);
    setError(null);
    setShowQRPopup(false);
    trackEventsForGuests("Interacted SplashLearn QR code Required Popup", {
      "mp_login_user_type": "student",
      "Clicked on": clickedOn
    }, {
      send_mixpanel: true
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "qr-code-popup",
    "data-sentry-component": "QRcodePopup",
    "data-sentry-source-file": "QRcodePopup.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "qr-code-overlay"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "qr-code-popup"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "iconcust-iconCross cross-icon",
    onClick: function onClick() {
      return scanAgain("Cross");
    }
  }), /*#__PURE__*/_react["default"].createElement(_soundIcon["default"], {
    className: "sound-icon",
    onClick: function onClick() {
      return audio.play();
    },
    "data-sentry-element": "SoundIconSvg",
    "data-sentry-source-file": "QRcodePopup.tsx"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, QRCodeExpired ? "The QR code is expired" : "SplashLearn QR code required"), /*#__PURE__*/_react["default"].createElement("p", null, QRCodeExpired ? "Ask your teacher for help." : "Please make sure that you are scanning the SplashLearn QR code."), /*#__PURE__*/_react["default"].createElement("div", {
    id: "qr-err-animation"
  }), /*#__PURE__*/_react["default"].createElement(_RenderAnimation["default"], {
    animationJSON: _qrError["default"],
    animationName: 'icon-animation',
    animationDivId: 'qr-err-animation',
    "data-sentry-element": "RenderAnimation",
    "data-sentry-source-file": "QRcodePopup.tsx"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "qr-code-btns"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "".concat(!QRCodeExpired ? "class-code" : ""),
    onClick: loginViaClassCode
  }, "Login via class code"), !QRCodeExpired ? /*#__PURE__*/_react["default"].createElement("button", {
    className: "scan-again",
    onClick: function onClick() {
      return scanAgain("Retry");
    }
  }, "Scan again") : null))));
};
var _default = exports["default"] = QRcodePopup;